import axiosInstance from "../Utils/axiosConfig";

const getCryptoPrice = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/api/get_crypto_price`
  );
  return response?.data;
};

const getFiatPrice = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/api/get_fiat_price`
  );
  return response?.data;
};

export const priceService = { getCryptoPrice, getFiatPrice };
